angular.module('IndicatorSearch').controller('IndicatorSearchController', [
  '$scope',
  '$filter',
  '$sce',
  '$timeout',
  '$uibModal',
  '$q',
  'SearchTrackingService',
  function ($scope, $filter, $sce, $timeout, $uibModal, $q, SearchTrackingService) {
    var searchData = jQuery('#hyperionSearch').data('json');
    var trackingId = Date.now() + makeid();
    var hyphenate = createHyphenator(hyphenationPatternsDe, {hyphenChar:'|'});
    var lastWord;
    var matchedMetaTags = [];
    $scope.loading = false;

    $scope.themes = searchData.themes;
    $scope.searchItems = searchData.results;
    $scope.tags = searchData.tags;
    $scope.types = searchData.types;
    $scope.typeUids = Object.keys(searchData.types);
    $scope.searchResults = [];
    $scope.searching = false;
    var lowercaseTags = [];
    for (var i = 0; i < searchData.tags.length; i++) {
      if (searchData.tags[i]) {
        lowercaseTags.push(searchData.tags[i].toLowerCase());
      }
    }

    $scope.searchInTitle = function () {
      $scope.tag = $scope.theme = '';
      $scope.searching = false;
    };

    $scope.searchInTheme = function () {
      $scope.tag = $scope.searchWord = '';
    };

    $scope.searchInTags = function () {
      $scope.theme = $scope.searchWord = '';
    };

    $scope.resultCount = function (type) {
      return function (item) {
        return item.types && item.types.indexOf(type) !== -1;
      };
    };

    const punctationless = function(string) {
      if(!string) return '';
      return string.replace(/[.,\/#!$?%\^&\*;:{}=\-_`~()]/g, "");
    };

    function filterStopWords(string) {
      if(!string) return '';
      return string.replace(/\b(aber|abermals|abgerufen|abgerufene|abgerufener|abgerufenes|ähnlich|alle|allein|allem|allemal|allen|allenfalls|allenthalben|aller|allerdings|allerlei|alles|allesamt|allgemein|allmählich|allzu|als|alsbald|also|alt|am|an|andauernd|andere|anderem|anderen|anderer|andererseits|anderes|andern|andernfalls|anders|anerkannt|anerkannte|anerkannter|anerkanntes|angesetzt|angesetzte|angesetzter|anscheinend|anstatt|auch|auf|auffallend|aufgrund|aufs|augenscheinlich|aus|ausdrücklich|ausdrückt|ausdrückte|ausgedrückt|ausgenommen|ausgerechnet|ausnahmslos|außen|außer|außerdem|außerhalb|äußerst|bald|bei|beide|beiden|beiderlei|beides|beim|beinahe|bekannt|bekannte|bekannter|bekanntlich|bereits|besonders|besser|bestenfalls|bestimmt|beträchtlich|bevor|bezüglich|bin|bis|bisher|bislang|bist|bloß|Bsp|bzw|ca|Co|da|dabei|dadurch|dafür|dagegen|daher|dahin|damals|damit|danach|daneben|dank|danke|dann|dannen|daran|darauf|daraus|darf|darfst|darin|darüber|darum|darunter|das|dass|dasselbe|davon|davor|dazu|dein|deine|deinem|deinen|deiner|deines|dem|demgegenüber|demgemäß|demnach|demselben|den|denen|denkbar|denn|dennoch|denselben|der|derart|derartig|deren|derer|derjenige|derjenigen|derselbe|derselben|derzeit|des|deshalb|desselben|dessen|desto|deswegen|dich|die|diejenige|dies|diese|dieselbe|dieselben|diesem|diesen|dieser|dieses|diesmal|diesseits|dir|direkt|direkte|direkten|direkter|doch|dort|dorther|dorthin|drin|drüber|drunter|du|dunklen|durch|durchaus|durchweg|eben|ebenfalls|ebenso|ehe|eher|eigenen|eigenes|eigentlich|ein|eine|einem|einen|einer|einerseits|eines|einfach|einig|einige|einigem|einigen|einiger|einigermaßen|einiges|einmal|einseitig|einseitige|einseitigen|einseitiger|einst|einstmals|einzig|e. K.|entsprechend|entweder|er|ergo|erhält|erheblich|erneut|erst|ersten|es|etc|etliche|etwa|etwas|euch|euer|eure|eurem|euren|eurer|eures|falls|fast|ferner|folgende|folgenden|folgender|folgendermaßen|folgendes|folglich|förmlich|fortwährend|fraglos|frei|freie|freies|freilich|für|gab|gängig|gängige|gängigen|gängiger|gängiges|ganz|ganze|ganzem|ganzen|ganzer|ganzes|gänzlich|gar|GbR|GbdR|geehrte|geehrten|geehrter|gefälligst|gegen|gehabt|gekonnt|gelegentlich|gemacht|gemäß|gemeinhin|gemocht|genau|genommen|genügend|genug|geradezu|gern|gestrige|getan|geteilt|geteilte|getragen|gewesen|gewiss|gewisse|gewissermaßen|gewollt|geworden|ggf|gib|gibt|gleich|gleichsam|gleichwohl|gleichzeitig|glücklicherweise|GmbH|Gott sei Dank|größtenteils|Grunde|gute|guten|hab|habe|halb|hallo|halt|hast|hat|hatte|hätte|hätte|hätten|hattest|hattet|häufig|heraus|herein|heute|heutige|hier|hiermit|hiesige|hin|hinein|hingegen|hinlänglich|hinten|hinter|hinterher|hoch|höchst|höchstens|ich|ihm|ihn|ihnen|ihr|ihre|ihrem|ihren|ihrer|ihres|im|immer|immerhin|immerzu|in|indem|indessen|infolge|infolgedessen|innen|innerhalb|ins|insbesondere|insofern|insofern|inzwischen|irgend|irgendein|irgendeine|irgendjemand|irgendwann|irgendwas|irgendwen|irgendwer|irgendwie|irgendwo|ist|ja|jährig|jährige|jährigen|jähriges|je|jede|jedem|jeden|jedenfalls|jeder|jederlei|jedes|jedoch|jemals|jemand|jene|jenem|jenen|jener|jenes|jenseits|jetzt|kam|kann|kannst|kaum|kein|keine|keinem|keinen|keiner|keinerlei|keines|keines|keinesfalls|keineswegs|KG|klar|klare|klaren|klares|klein|kleinen|kleiner|kleines|konkret|konkrete|konkreten|konkreter|konkretes|können|könnt|konnte|könnte|konnten|könnten|künftig|lag|lagen|langsam|längst|längstens|lassen|laut|lediglich|leer|leicht|leider|lesen|letzten|letztendlich|letztens|letztes|letztlich|lichten|links|Ltd|mag|magst|mal|man|manche|manchem|manchen|mancher|mancherorts|manches|manchmal|mehr|mehrere|mehrfach|mein|meine|meinem|meinen|meiner|meines|meinetwegen|meist|meiste|meisten|meistens|meistenteils|meta|mich|mindestens|mir|mit|mithin|mitunter|möglich|mögliche|möglichen|möglicher|möglicherweise|möglichst|morgen|morgige|muss|müssen|musst|müsst|musste|müsste|müssten|nach|nachdem|nachher|nachhinein|nächste|nämlich|naturgemäß|natürlich|neben|nebenan|nebenbei|nein|neu|neue|neuem|neuen|neuer|neuerdings|neuerlich|neues|neulich|nicht|nichts|nichtsdestotrotz|nichtsdestoweniger|nie|niemals|niemand|nimm|nimmer|nimmt|nirgends|nirgendwo|noch|nötigenfalls|nun|nunmehr|nur|ob|oben|oberhalb|obgleich|obschon|obwohl|oder|offenbar|offenkundig|offensichtlich|oft|ohne|ohnedies|OHG|OK|partout|per|persönlich|plötzlich|praktisch|pro|quasi|recht|rechts|regelmäßig|reichlich|relativ|restlos|richtiggehend|riesig|rund|rundheraus|rundum|sämtliche|sattsam|schätzen|schätzt|schätzte|schätzten|schlechter|schlicht|schlichtweg|schließlich|schlussendlich|schnell|schon|schwerlich|schwierig|sehr|sei|seid|sein|seine|seinem|seinen|seiner|seines|seit|seitdem|Seite|Seiten|seither|selber|selbst|selbstredend|selbstverständlich|selten|seltsamerweise|sich|sicher|sicherlich|sie|siehe|sieht|sind|so|sobald|sodass|soeben|sofern|sofort|sog|sogar|solange|solch|solche|solchem|solchen|solcher|solches|soll|sollen|sollst|sollt|sollte|sollten|solltest|somit|sondern|sonders|sonst|sooft|soviel|soweit|sowie|sowieso|sowohl|sozusagen|später|spielen|startet|startete|starteten|statt|stattdessen|steht|stellenweise|stets|tat|tatsächlich|tatsächlichen|tatsächlicher|tatsächliches|teile|total|trotzdem|übel|über|überall|überallhin|überaus|überdies|überhaupt|üblicher|übrig|übrigens|um|umso|umstandshalber|umständehalber|unbedingt|unbeschreiblich|und|unerhört|ungefähr|ungemein|ungewöhnlich|ungleich|unglücklicherweise|unlängst|unmaßgeblich|unmöglich|unmögliche|unmöglichen|unmöglicher|unnötig|uns|unsagbar|unsäglich|unser|unsere|unserem|unseren|unserer|unseres|unserm|unstreitig|unten|unter|unterbrach|unterbrechen|unterhalb|unwichtig|unzweifelhaft|usw|vergleichsweise|vermutlich|viel|viele|vielen|vieler|vieles|vielfach|vielleicht|vielmals|voll|vollends|völlig|vollkommen|vollständig|vom|von|vor|voran|vorbei|vorher|vorne|vorüber|während|währenddessen|wahrscheinlich|wann|war|wäre|waren|wären|warst|warum|was|weder|weg|wegen|weidlich|weil|Weise|weiß|weitem|weiter|weitere|weiterem|weiteren|weiterer|weiteres|weiterhin|weitgehend|welche|welchem|welchen|welcher|welches|wem|wen|wenig|wenige|weniger|wenigstens|wenn|wenngleich|wer|werde|werden|werdet|weshalb|wessen|wichtig|wie|wieder|wiederum|wieso|wiewohl|will|willst|wir|wird|wirklich|wirst|wo|wodurch|wogegen|woher|wohin|wohingegen|wohl|wohlgemerkt|wohlweislich|wollen|wollt|wollte|wollten|wolltest|wolltet|womit|womöglich|woraufhin|woraus|worin|wurde|würde|würden|z. B.|zahlreich|zeitweise|ziemlich|zu|zudem|zuerst|zufolge|zugegeben|zugleich|zuletzt|zum|zumal|zumeist|zur|zurück|zusammen|zusehends|zuvor|zuweilen|zwar|zweifellos|zweifelsfrei|zweifelsohne|zwischen)\b/gi, "");
    }

    const hyphanetedRegEx = function(string) {
      var test = new RegExp(hyphenate('(' + string.split(' ').join(')|(') + ')'), 'gi');
      return test;
    };

    $scope.searchFilter = function (item) {
      if ($scope.theme && item.themes && item.themes.indexOf($scope.theme) !== -1) {
        return true;
      }

      // // not used yet
      // if ($scope.tag && item.tags.indexOf($scope.tag) !== -1) {
      //   return true;
      // }
      // if ($scope.searchWord && $scope.searchWord.length > 1 && lowercaseTags.indexOf($scope.searchWord.toLowerCase()) !== -1) {
      //   $scope.tag = $scope.tags[lowercaseTags.indexOf($scope.searchWord.toLowerCase())];
      //   $scope.searchWord = '';
      //   $scope.searchFilter(item);
      // }
      if ($scope.searchWord) {
        var workingInput = punctationless(filterStopWords($scope.searchWord)).trim();
        if (!workingInput || workingInput.length < 3) return false;
        var workingTitle = punctationless(filterStopWords(item.title)).trim();

        // console.log("-- PercentageMatching: " + item.title);
        percentageMatching(item, workingInput);

        var regexp = hyphanetedRegEx(workingTitle);
        var matches = workingInput.match(regexp);
        item.titleMatching = matches ? matches.join('').length/workingTitle.length : 0;

        if (item.tagHits > 0) return true;
        if (item.themeHits > 0) return true;
        if (item.title && workingInput && item.title.toLowerCase().indexOf(workingInput.toLowerCase()) !== -1) return true;
      }

      return false;
    };

    $scope.$watch('searchWord', function (searchWord) {
      if (!searchWord) return;
      lastWord = searchWord;

      setTimeout(function () {
        if (lastWord == searchWord) {
          SearchTrackingService.writeLog(trackingId, searchWord, $scope.theme, matchedMetaTags || []);
          matchedMetaTags = [];
        }
      }, 3000);
    });

    $scope.$watch('theme', function (theme) {
      if (!theme) return;
      SearchTrackingService.writeLog(trackingId, $scope.searchWord, theme);
    });

    function filterByMatch(input) {
      return function(string) {
        var regexp = hyphanetedRegEx(string),
          searchWord,
          searchInput = input,
          matches = searchInput.match(regexp),
          percentToHit = .65;

        if (!string) return false;

        // if (matches) console.log("MATCHES:", matches, string, regexp);
        var percentMatch = matches ? matches.join('').length / searchInput.length : false;
        // if(matches) console.log("TAG:", string, "INPUT:", searchInput, "matches: ", matches, matches.join(''), "percent: " + matches.join('').length + " / " + searchInput.length + " = ", percentMatch);
        if (matches && percentMatch > percentToHit) {
          return true;
        }
        var searchWords = searchInput.split(' ');
        for (var i = 0; i < searchWords.length; i++) {
          searchWord = searchWords[i];
          matches = searchWord.match(regexp);
          if (!matches || !string) return false;
          // if (matches) console.log("MATCHES Words:", matches, string);
          percentMatch = matches.join('').length / searchWord.length;
          if (percentMatch > percentToHit) return true;
        }
      }
    }

    // personalschlüssel
    function percentageMatching(item, input) {
      if(item.metaTags) {
        var filteredTags = item.metaTags.filter(filterByMatch(input));
        item.tagHits = filteredTags.length;
        matchedMetaTags = matchedMetaTags.concat(filteredTags);
        // if(matchedMetaTags.length) console.log("matchedMetaTags", matchedMetaTags.unique());
      } else {
        item.tagHits = 0;
      }
      item.themeHits = item.themes ? item.themes.filter(filterByMatch(input)).length : 0;
    }

    function makeid() {
      var text = "";
      var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

      for (var i = 0; i < 5; i++)
        text += possible.charAt(Math.floor(Math.random() * possible.length));

      return text;
    }

  }]);
